
const textfieldValidator = require('../../../../../components/textfield/textfield-validator')
const validator          = require('../../../../../components/textfield/validator.min')
const snackUsers         = require('./users-snack')
const textfieldHandler   = require('../../../../../components/textfield/textfield-handler')


export async function checkUsernameInput(htmlFc,FromButton = false) {
      let usernameInput = htmlFc.fullcontHTML.querySelector('#users_form_username input');

      // Crear un nuevo objeto detailInput, para que siempre tenga el evento correcto
      let detailInput = {};
      detailInput.ev = {};
      detailInput.ev.target = usernameInput;

      let username = usernameInput.value.trim();

      if (validator.isEmail(username)) {

            if (!await checkUsernameDB(username,htmlFc)) {
                textfieldValidator.completed(detailInput.ev);
            } else {
                textfieldValidator.incomplete(detailInput.ev, 'Username already exists');
                if (FromButton) {
                    textfieldHandler.error(usernameInput.parentElement);
                }

                return false;
            }
    
      } else {
            textfieldValidator.incomplete(detailInput.ev, 'Invalid username');
            if (FromButton) {
                textfieldHandler.error(usernameInput.parentElement);
            }

            return false;
      }

      return true;

}


async function checkUsernameDB(username,htmlFc) {

    let objToSend = { username: username };

    const infNewData = getFormData(objToSend);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);

    let options = {
        method: 'POST',
        body: infNewData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    try {
        const response = await fetch(`server/php/sql/checkUsername.php`, options);
        const result = await response.json();

        clearTimeout(timeout);

        if (result.code == 200) {
            return true;
        }else{
            return false;
        }

    } catch (error) {
        console.error('Error en checkEmailDB:', error);
        //esto para que se detenga el proceso si hay error
        return true;
    }
}

export function sendUsernameEmail(data,htmlFc) {

    let infNewData = null;
    //para saber si se enviara el correo para un nuevo usuario o para un usuario existente
    if (data.new_user) {
        infNewData =  getFormData({email: data.username, name: data.__name, last_name: data.last_name, new_user: 1, type: 'password_reset'})
    }else{
        infNewData =  getFormData({email: data.username, name: data.__name, last_name: data.last_name, type: 'password_reset'})
    }
    //object > FormData()
    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = { method: 'POST', body: infNewData, signal: controller.signal, credentials: 'same-origin' };

    fetch(`server/php/send-emails/sendEmail.php`, options)
        .then(result => {
            return result.json()
        })
        .then((result) => {
            // esto es porque cuando se guarda se tiene un snack automatico, este snack se mostrara luego del principal
            let snack = document.getElementById('snack');
            if (snack.classList.contains("show")) {
                setTimeout(() => {
                    if (result.code != 200) {
                        snackUsers.start({ act: 'show',id: 'errorSendEmail', addTitle: result.message });
                    } else {
                        snackUsers.start({ act: 'show', id: 'emailWasSent' });
                    }
                }, 5500);

            } else {
                if (result.code != 200) {
                    snackUsers.start({ act: 'show', id: 'errorSendEmail', addTitle: result.message });
                } else {
                    snackUsers.start({ act: 'show', id: 'emailWasSent' });
                }
            }
        })
        .catch((error) => { // 
            console.log('result 3', 'ERRORRRRRRRR');
            throw error;
        })

}

function getFormData(object) {
    const formData = new FormData()
    Object.keys(object).forEach(key => formData.append(key, object[key]))
    return formData
}

export function sendEmailFromButton(htmlFc) {
 

    let usernameInput = htmlFc.fullcontHTML.querySelector('#users_form_username input');
    let username = usernameInput.value.trim();
    let name = '';
    let last_name = '';

    htmlFc.form.forEach(element => {
        if (element.name === '__name') {
            name = element.value;
        }
        if (element.name === 'last_name') {
            last_name = element.value;
        }
    });

    sendUsernameEmail({ username: username, __name: name, last_name: last_name, new_user: false }, htmlFc);

}

export function showButtonResetPassword(htmlFc) {
    let resetButton = htmlFc.fullcontHTML.querySelector('.reset_password');
    resetButton.classList.remove('dn');
}

export function hideButtonResetPassword(htmlFc) {
    let resetButton = htmlFc.fullcontHTML.querySelector('.reset_password');
    resetButton.classList.add('dn');
}
